/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResourceCreated
 */
export interface ResourceCreated {
    /**
     * 
     * @type {string}
     * @memberof ResourceCreated
     */
    id: string;
}

/**
 * Check if a given object implements the ResourceCreated interface.
 */
export function instanceOfResourceCreated(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function ResourceCreatedFromJSON(json: any): ResourceCreated {
    return ResourceCreatedFromJSONTyped(json, false);
}

export function ResourceCreatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceCreated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function ResourceCreatedToJSON(value?: ResourceCreated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

